import React, { Dispatch, SetStateAction } from "react";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  leadProducts: { label: string; value: string; idLeadCorretor: string };
  setLeadProducts: Dispatch<
    SetStateAction<{ label: string; value: string; idLeadCorretor: string }>
  >;
  setOpenModalEscolherOpcao: (val: boolean) => void;
  dataResumo: any;
  setOpenModalProposta?: Dispatch<SetStateAction<boolean>>;
  selectedItem?: any;
}

const VincularLeadModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        onClose={() => props?.onClose()}
        leadProducts={props?.leadProducts}
        setLeadProducts={props?.setLeadProducts}
        setOpenModalEscolherOpcao={props?.setOpenModalEscolherOpcao}
        dataResumo={props?.dataResumo}
        setOpenModalProposta={props?.setOpenModalProposta}
        selectedItem={props?.selectedItem}
      />
    </Styles.Container>
  );
};

export default VincularLeadModal;
